module.exports = {
    "dismiss": `Schlie\xdfen`
};


//# sourceMappingURL=de-DE.main.js.map
